<template>
  <nav class="tabs">
    <ul>
      <router-link
        tag="li"
        :to="tab.push"
        :key="index"
        :class="{ active: tab.push.name && tab.push.name === $route.name }"
        v-for="(tab, index) in tabs">
        <span class="inline-flex items-center">
          <span>{{ tab.title }}</span>
          <span
            v-if="Number(tab.badge) > 0"
            class="ml-2 inline-flex items-center justify-center min-w-18px h-18px px-1 rounded-full bg-danger text-white text-11px leading-11px font-bold">
            {{ tab.badge }}
          </span>
        </span>
      </router-link>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  watch: {
    '$route.name': function routeChanged() {
      this.revealActiveTab('smooth');
    },
    tabs() {
      this.revealActiveTab('auto');
    },
  },
  mounted() {
    this.revealActiveTab('auto');
  },
  methods: {
    revealActiveTab(behavior = 'auto') {
      this.$nextTick(() => {
        if (typeof window === 'undefined' || !window.matchMedia('(max-width: 767px)').matches) return;
        const nav = this.$el;
        const active = nav && nav.querySelector ? nav.querySelector('li.active') : null;
        if (!nav || !active) return;
        const targetLeft = active.offsetLeft - ((nav.clientWidth - active.offsetWidth) / 2);
        if (typeof nav.scrollTo === 'function') {
          nav.scrollTo({ left: Math.max(0, targetLeft), behavior });
        } else {
          nav.scrollLeft = Math.max(0, targetLeft);
        }
      });
    },
  },
};
</script>
